export const SET_HIGHLIGHTED_PAGES = "SET_HIGHLIGHTED_PAGES";

export default function setHighlightedPages(highlightedPages) {
  return {
    type: SET_HIGHLIGHTED_PAGES,
    payload: highlightedPages,
  };
}
